function equalizeCardContentHeights() {
  const cards = document.querySelectorAll('#product-grid .grid__item');
  const rows = {};

  // Reset heights
  cards.forEach(card => {
    const content = card.querySelector('.card__content');
    if (content) content.style.height = 'auto';
  });

  // Group cards by row (top offset)
  cards.forEach(card => {
    const top = card.getBoundingClientRect().top;
    if (!rows[top]) rows[top] = [];
    rows[top].push(card);
  });

  // Set each content in the row to the tallest
  Object.values(rows).forEach(row => {
    let maxHeight = 0;
    row.forEach(card => {
      const content = card.querySelector('.card__content');
      if (content) {
        const height = content.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      }
    });
    row.forEach(card => {
      const content = card.querySelector('.card__content');
      if (content) content.style.height = maxHeight + 'px';
    });
  });
}

// Run on load and on resize
window.addEventListener('load', equalizeCardContentHeights);
window.addEventListener('resize', equalizeCardContentHeights);

// Hide price for Vinyl Collection Product
document.addEventListener('DOMContentLoaded', function () {
  const titleLinks = document.querySelectorAll('#product-grid .card__heading a');
  titleLinks.forEach(link => {
    const titleText = link.textContent.trim().toLowerCase();
    if (titleText === 'vinyl collection') {
      const productCard = link.closest('.grid__item');

      if (productCard) {
        const price = productCard.querySelector('.price');
        if (price) {
          price.style.display = 'none';
        }
      }
    }
  });
});

